import {Mapper} from '@s-ui/domain'

export class FromSubscriptionMakesRawDataToMakesListValueObjectMapper extends Mapper {
  constructor({makeEntityFactory, makesListValueObjectFactory}) {
    super()
    this._makeEntityFactory = makeEntityFactory
    this._makesListValueObjectFactory = makesListValueObjectFactory
  }

  map = subscriptionMakesRawData => {
    const {items = []} = subscriptionMakesRawData
    const makesEntities = items.map(({id, name, slug}) => {
      return this._makeEntityFactory({
        id,
        name,
        slug
      })
    })
    return this._makesListValueObjectFactory({items: makesEntities})
  }
}
